import styled, { css } from "styled-components";
import { shade } from 'polished';
import { TabHeader } from '../../styles/components';

import Background from "../../assets/header/fundo-procuracao.png";
import BackgroundMobile from "../../assets/header/fundo-procuracao-mobile.svg";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  padding-top: 5.5rem;
  padding-bottom: 9.3125rem;
  width: 100%;
  height: auto;

  @media screen and (max-width: 950px) {
    .customTab {
      background: var(--white);
      box-shadow: var(--shadow-baixo-pequena);
    }
  }

  @media screen and (max-width: 425px) {
    .customTab {
      margin-top: 36px;
    }
  }
`;

export const PageHeader = styled.section`
    display: flex;
    justify-content: center;
    width: 100vw;
    background: url(${Background}) no-repeat right top;

    @media screen and (max-width: 950px) {
      background-size: contain;
    }

    @media screen and (max-width: 425px) {
      background: url(${BackgroundMobile}) no-repeat right top;
    }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  max-width: 80rem;
  max-height: 25.75rem;
  padding: 18px 0 36px;
  position: relative;

  h3 {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 800;
    margin-bottom: 1.5rem;
  }

  @media screen and (max-width: 950px) {
    flex-direction: column;
    padding: 20px 16px 32px;

    img.frameDesktop {
      max-width: 180px;
      margin: 44px 0 16px;
    }
  }

  @media screen and (min-width: 425px) {
    img.frameMobile {
      display: none;
    }
  }

  @media screen and (max-width: 425px) {
    img {
      &.frameDesktop {
        display: none;
      }
      &.frameMobile {
        position: absolute;
        top: 14px;
        left: 21px;
      }
    }
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 50px;

  > P {
    font-size: 17px;
    line-height: 28px;
    color: var(--cinza-90);

    &.title {
      letter-spacing: 1.5px;
      text-transform: uppercase;
      margin-bottom: 8px;
    }

    &.description {
      max-width: 495px;
    }
  }

  > h2 {
    font-size: 32px;
    line-height: 36px;
    color: var(--cinza-100);
    max-width: 415px;
    margin-bottom: 16px;

    > span {
      color: var(--principal-50);
    }
  }

  &.defaultInfo {
    width: 100vw;

    > p {
      width: 100%;
      max-width: 80rem;
      margin-left: auto;
      margin-right: auto;
    }

    @media screen and (max-width: 950px) {
      padding: 0 16px;
    }
  }

  @media screen and (max-width: 425px) {
    margin-top: 90px;

    h2 {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: 950px) {
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
    padding-left: 8px;
  }
`;

export const MobileInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: var(--principal-50);

  p {
    font-size: 15px;
    line-height: 24px;
    color: var(--principal-50);
    letter-spacing: 0.2px;
  }

  @media screen and (min-width: 951px) {
  }
`;

export const TooltipInfo = styled.div`
  transition: all 0.5s ease-in-out;
  opacity: ${({ active }) => active ? 1 : 0};
  text-align: left;
  width: 24.25rem;
  background: black;
  border-radius: 8px;
  padding: 1rem;
  position: absolute;
  top: 170%;
  left: -3%;
  ${({ active }) => active ? 'z-index: 10;' : 'z-index: -1;'}

  > p{
    font-size: 17px;
    line-height: 28px;
    color: var(--white);

    &:first-child {
      margin-bottom: 8px;
    }
  }

  &:after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 7%;
    margin-left: -12px;
    border-width: 12px;
    border-style: solid;
    border-color: transparent transparent black transparent;
  }

  @media screen and (max-width: 425px) {
    top: 160%;
    right: 4px;

    &:after {
      left: 8.5%;
    }
  }
`;

export const ContentRequests = styled.div`
  display: ${({ active }) => active ? "flex" : "none"};
  flex-direction: column;
  width: 100%;

  ${(props) => !props.border && css`
    .borderNone {
      border-bottom: 0;
    }
  `}

  &.no-accordion {
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 24px;
    padding: 0 24px;

    ${TabHeader} {
      padding-left: 0;
      padding-right: 0;
    }
  }

  @media screen and (max-width: 767px) {
    .MuiAccordionSummary-content {
      flex-direction: column;
      margin: 24px 0;
    }

    .MuiButtonBase-root {
      padding: 0 16px;
    }
  }
`;

export const CardRequests = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 24px;
`;

export const AccordionHeading = styled.div`
  display: flex;
  width: 100%;

  p {
    font-size: 1.1875rem;
    line-height: 1.75rem;
    font-weight: bold;
    color: var(--cinza-100);
    margin-right: 1rem;

    &.countPasso {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--principal-40);
        color: var(--white);
        margin-right: 0.5rem;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
    }

    &.passo {
        display: flex;
        align-items: center;
        color: var(--principal-50);
        margin-right: 1.5rem; 
    }

    &.contador,
    &.contadorMobile {
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: 1.5625rem;
        padding: 0 0.5625rem;
        background: var(--cinza-30);
        color: var(--cinza-80);
        border-radius: 6.25rem;
        margin: 0;
    }

    &.contadorMobile {
        display: none;
    }
  }
`;

export const AccordionDescription = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.1875rem;
    line-height: 1.75rem;
    font-weight: bold;
    width: 100%;
    max-width: 36rem;
    margin-right: 1.6875rem;

    span {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    img {
        margin-right: 0.5rem;
    }

    p {
        font-size: 19px;
        line-height: 1.75rem;
        font-weight: bold;
        color: var(--cinza-100);
        margin-right: 1rem;

        &.countPasso {
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--principal-40);
            color: var(--white);
            margin-right: 0.5rem;
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
        }

        &.passo {
            display: flex;
            align-items: center;
            color: var(--principal-50);
            margin-right: 1.5rem; 
        }

        &.contador,
        &.contadorMobile {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            max-height: 1.5625rem;
            padding: 0 0.5625rem;
            background: var(--cinza-30);
            color: var(--cinza-80);
            border-radius: 6.25rem;
            margin: 0;
        }

        &.contadorMobile {
            display: none;
        }
    }

    @media screen and (max-width: 1100px) {
    }

    @media screen and (max-width: 950px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;

        p {
            &.countPasso {
                display: none;
            }

            &.contador {
                display: none;
            }

            &.contadorMobile {
                display: flex;
            }

            &.title {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
            }
        }
    }

    @media screen and (max-width: 767px) {
      p {
        font-size: 17px;

        &.contadorMobile {
          font-size: 15px;
        }
      }
    }
`;

export const AccordionStatus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${({ color }) => [color]};

    svg {
        margin-right: 1.125rem;
    }

    p {
        font-size: 1.1875rem;
        line-height: 1.75rem;
        /* color: var(--cinza-100); */
        margin-right: 1rem;
    }

    @media screen and (max-width: 950px) {
        margin-top: 4px;
    }
`;

export const AccordionButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
  position: relative;

  @media screen and (max-width: 950px) {
    width: 100%;

    button {
      margin-top: 24px;
    }

    span {
      position: absolute;
      right: 0;
      top: -50px;
    }
  }

  @media screen and (max-width: 767px) {
    position: unset;
  }
`;

export const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 0.7s;
  transition-property: transform;
  margin-left: 1.5rem;
  background: var(--cinza-20);
  width: 40px;
  height: 40px;
  border-radius: 50%;

  svg {
    width: 40px;
  }

  ${({ active }) => active
    ? `transform: rotate(180deg);
    -webkit-transform: rotate(180deg);`
    : ""
  }

  @media screen and (max-width: 767px) {
    position: absolute;
    top: 54px;
    right: 16px;
  }
`;

export const AccordionDetailHeader = styled.p`
  display: flex;
  padding-bottom: 8px;
  width: 100%;
  font-size: 17px;
  line-height: 28px;
  color: var(--cinza-90);
`;

export const AccordionDetailBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  row-gap: 24px;
  column-gap: 52px;
  width: 100%;

  @media screen and (max-width: 950px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const InfoProcuracao = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 80rem;
  margin: 64px auto 0;

  > h3 {
    font-size: 24px;
    line-height: 32px;
    color: var(--cinza-90);
  }

  > p {
    font-size: 17px;
    line-height: 28px;
    color: var(--cinza-90);
    max-width: 600px;
    margin: 16px 0 32px;
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 17px;
    line-height: 28px;
    font-weight: 700;
    background: var(--principal-40);
    color: var(--cinza-100);
    border-radius: 8px;
    padding: 12px 24px 12px 16px;
    max-width: 264px;
    text-decoration: none;
    transition: all 0.2s;

    &:hover {
      background: ${shade(0.1, "#32C050")};
    }
  }

  @media screen and (max-width: 950px) {
    padding: 0 16px;
  }
`;
